import { PaymentElementProps } from '@stripe/react-stripe-js';

export const PAYMENT_OPTIONS: PaymentElementProps = {
  options: {
    fields: {
      billingDetails: {
        address: 'never',
        name: 'never',
      },
    },
  },
};
